exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-status{float:left}.include-date-scroll{top:6rem;position:absolute;bottom:0;width:100%;overflow-y:auto;padding-bottom:.5rem;background:#eff2f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b856da9","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/myregister/MyRegister.vue
// module id = 436
// module chunks = 0